export default __webpack_public_path__ + "static/logo-ey-ddc811242c3a0178d4248770852eea46.svg";